import { AddTemplateDrawer } from 'src/pages/ClinicalTrial/ClinicalTrialForms/drawers/AddTemplateDrawer';
import { AssignFormDrawer } from 'src/pages/ClinicalTrial/ClinicalTrialForms/drawers/AssignFormDrawer';
import { CloseOutlined } from '@ant-design/icons';

export const drawers = {
  template: AddTemplateDrawer,
  form: AssignFormDrawer,
};

export const drawersProps = {
  classNames: {
    header:
      '!px-0 [&_button]:absolute [&_button]:top-[1.3rem] [&_button]:right-[0.4rem]',
    body: 'flex flex-col !pl-0 !pr-2',
    content: 'rounded-lg',
  },
  open: true,
  width: 464,
  closeIcon: <CloseOutlined data-testid='close-drawer-button' />,
};
